import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';

export const PremiumFeatureLock = ({ title, description }) => {
    const { subscription } = useAuth();
    
    // Return null if user has premium access
    if (subscription === 'premium') {
        return null;
    }

    return (
        <Card className="card-one">
            <Card.Body className="p-5 text-center">
                <i className="ri-lock-2-line fs-48 text-primary mb-4"></i>
                <h4>{title}</h4>
                <p className="text-muted mb-4">{description}</p>
                <Link to="/dashboard/pricing">
                    <Button variant="primary">
                        Upgrade to Premium
                        <i className="ri-arrow-right-line ms-2"></i>
                    </Button>
                </Link>
            </Card.Body>
        </Card>
    );
}; 